import styled from "styled-components";

export const ChangeRateTypeModalStyled = styled.div`
  width: 600px;
  height: 175spx;
  padding: 25px;
`;
